import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import Loading from '../../features/shared/components/Loading'

export default function PublicLayout() {
  return (
    <div>
      <Suspense fallback={<Loading />}>
        <Outlet />
      </Suspense>
    </div>
  )
}
